<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filtres
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0"
        >
          <label>État</label>
          <v-select
            :value="stateValue"
            :options="stateOptions"
            class="w-100"
            @input="(val) => changeFilter(val, 'STATE')"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0"
        >
          <label>Device</label>
          <v-select
            :value="deviceValue"
            :options="deviceOptions"
            class="w-100"
            @input="(val) => changeFilter(val, 'DEVICE')"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0"
        >
          <label>Personne</label>
          <v-select
            :value="personValue"
            :options="personOptions"
            class="w-100"
            @input="(val) => changeFilter(val, 'PERSON')"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="d-flex justify-content-end align-items-end"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline"
            class="btn-icon"
            @click="resetFilters"
          >
            Réinitialiser
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    stateOptions: {
      type: Array,
      required: true,
    },
    stateValue: {
      type: String,
      default: null,
    },
    personOptions: {
      type: Array,
      required: true,
    },
    personValue: {
      type: String,
      default: null,
    },
    deviceOptions: {
      type: Array,
      required: true,
    },
    deviceValue: {
      type: String,
      default: null,
    },
  },
  methods: {
    resetFilters() {
      this.$emit('update:stateValue', null)
      this.$emit('update:personValue', null)
      this.$emit('update:deviceValue', null)
    },
    changeFilter(value, filter) {
      if (filter === 'STATE') {
        this.$emit('update:stateValue', value)
      }
      if (filter === 'PERSON') {
        this.$emit('update:personValue', value)
      }
      if (filter === 'DEVICE') {
        this.$emit('update:deviceValue', value)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
